
import { defineComponent } from "vue";
import StatCard from "@/components/dashboard/sequence/StatCard.vue";
import { getBalanceDetails } from "@/api/dashboard";
import { getCurrentUser } from "@/utils/index";

export default defineComponent({
  name: "productgcbalances",
  components: {
    StatCard,
  },
  props: {
    widgetClasses: String,
  },
  data() {
    return {
      balancedetails: {} as any,
      user: {} as any,
      loadingBalance: true,
      pt: "",
      ccode: -1,
    };
  },
  computed: {
    ewalletCurrency(): string {
      return this.balancedetails.currency == "ZAR" ? "PHP" : this.balancedetails.currency || "";
    },
  },
  methods: {
    async getBalanceDetails() {
      this.loadingBalance = true;
      const response = await getBalanceDetails();
      this.balancedetails = response.data;
      this.loadingBalance = false;
    },
  },
  mounted() {
    this.user = getCurrentUser();
    this.pt = String(localStorage.getItem("pt"));
    this.ccode = Number(localStorage.getItem("ccode"));
    this.getBalanceDetails();
  },
});
